import React,{Component} from 'react';
import Select from '@react/react-spectrum/Select';
import i18n from '../../i18n';
import _ from 'lodash';
import {connect} from "react-redux";
import {setUserLocale,setGlobalNavLocale,setGoUrlLocale} from '../../actions/LocaleActions';
import store from '../../stores/store';
import moment from 'moment';
import 'moment/min/locales';

export class SelectLanguage extends Component{
    constructor(props){
        super(props);
        this.selectedLocale = {};
        this.setLocale();
    }


    setLocale(){
        if(localStorage.getItem('userLang') && localStorage.getItem('userLang') !== undefined && localStorage.getItem('userLang') !== ''){
            if(this.props.availableLocales && this.props.availableLocales.length){
                this.selectedLocale = _.find(this.props.availableLocales,function (obj) {
                    return obj.value === localStorage.getItem('userLang')
                });
                i18n.changeLanguage(this.selectedLocale.langCode);
            }
            if(this.selectedLocale.langCode && this.selectedLocale.langCode !== 'en') {
                moment().locale(this.selectedLocale.langCode);
            }
        }else{
            i18n.changeLanguage('en');
        }
    }

    change(event){
        this.props.setUserInfoLocale(event);
        if(event){
            localStorage.setItem('userLang', event);
            let locale = this.props.availableLocales.filter(obj => obj.value === event)
            let goUrlLocale = "en";
            let splittedLocale = '', languageCode = '', globalLocale = 'en_US';
            if(locale.length){
                splittedLocale = locale[0].langCode.split('-');
                goUrlLocale = locale[0].langCode;
                languageCode = locale[0].langCode;
                if(splittedLocale.length === 2){
                    goUrlLocale = splittedLocale[0] + "_" + splittedLocale[1].toUpperCase();
                    languageCode = splittedLocale[0];
                }
                this.props.setGoUrlLocale(goUrlLocale);
                globalLocale = languageCode +'_'+locale[0].countryCode;
                this.props.setAdobeGlobalNavLocale(globalLocale);
                localStorage.setItem('globalLocale', globalLocale);
            }
            else{
                localStorage.setItem('globalLocale', globalLocale);
                this.props.setAdobeGlobalNavLocale(globalLocale);
                this.props.setGoUrlLocale(goUrlLocale);
            }
        }else{
            localStorage.setItem('userLang', 'en');
        }
        window.location.reload();
        this.setLocale();
    };

    componentDidMount() {
        store.dispatch({type: 'LOAD_LANG_CONFIG'});
        //this.setLocale();
    }

    render(){
        if(this.props.localeStatus){this.setLocale();}
        return(

            <Select
                onChange={this.change.bind(this)}
                options={this.props.availableLocales}
                closeOnSelect={true}
                value={this.props.value}
                quiet
                flexible
            />
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        value:state.LocaleReducer.value,
        availableLocales:state.LocaleReducer.availableLocales,
        userInfo:state.AuthReducer.userInfo,
        localeStatus: state.LocaleReducer.localeStatus
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        setUserInfoLocale:(locale)=>{dispatch(setUserLocale(locale))},
        setAdobeGlobalNavLocale:(locale)=>{dispatch(setGlobalNavLocale(locale))},
        setGoUrlLocale:(locale)=>{dispatch(setGoUrlLocale(locale))}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(SelectLanguage);

